var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help_main"},[_c('iframe',{staticStyle:{"width":"100%","height":"700px"},attrs:{"src":"/Help-demo.pdf"}})])
}]

export { render, staticRenderFns }